import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Spin, Typography } from 'antd';
import { type SpinProps } from 'antd/es/spin/index';
import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LoaderSpinWrapper } from './LoaderSpin.style.tsx';

export interface LoaderSpinProps extends SpinProps {
  full?: boolean;
  transparent?: boolean;
  hasScroll?: boolean;
  children?: React.ReactNode;
  /** Mette a tutta larghezza il contenuto */
  hasFullWidthChildren?: boolean;
  /** Rimuove il padding */
  noPadding?: boolean;
}

/**
 * Spinning Loader.
 */
export function LoaderSpin(props: LoaderSpinProps) {
  const {
    full,
    transparent,
    hasScroll,
    hasFullWidthChildren,
    noPadding,
    ...otherProps
  } = props;
  const { t } = useTranslation();

  const divProps = {
    full,
    transparent,
    hasScroll,
    hasFullWidthChildren,
    noPadding,
  };

  return (
    <LoaderSpinWrapper {...divProps}>
      <Spin
        size="large"
        {...otherProps}
        indicator={
          <Loading3QuartersOutlined
            spin
            aria-label={t('loader.loader-spin.icon-aria', 'Caricamento...')}
          />
        }
      />
      {/* 
        Ant non rende possibile mostrare un messaggio di caricamento se non 
        è presente il children, quindi lo renderizziamo a mano 
      */}
      {otherProps.tip && !otherProps.children && (
        <Typography.Text type="secondary">{otherProps.tip}</Typography.Text>
      )}
    </LoaderSpinWrapper>
  );
}
